/**
 * @generated SignedSource<<2eafb1ac8d4315f1f4e838f669974905>>
 * @relayHash d2a48905b573ac486ae1fdc23d104aae
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d2a48905b573ac486ae1fdc23d104aae

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type CodeScanningSecurityAlertStatus = "DISMISSED" | "FIXED" | "OPEN" | "%future added value";
export type IssueState = "CLOSED" | "OPEN" | "%future added value";
export type IssueStateReason = "COMPLETED" | "DUPLICATE" | "NOT_PLANNED" | "REOPENED" | "%future added value";
export type PullRequestState = "CLOSED" | "MERGED" | "OPEN" | "%future added value";
export type IssueViewerSubscriptionMetadataSubscription$variables = {
  issueId: string;
};
export type IssueViewerSubscriptionMetadataSubscription$data = {
  readonly issueUpdated: {
    readonly commentReactionUpdated: {
      readonly " $fragmentSpreads": FragmentRefs<"ReactionViewerRelayGroups">;
    } | null | undefined;
    readonly commentUpdated: {
      readonly issue: {
        readonly " $fragmentSpreads": FragmentRefs<"PinnedCommentDisplay">;
      };
      readonly " $fragmentSpreads": FragmentRefs<"IssueCommentEditorBodyFragment" | "IssueCommentViewerMarkdownViewer">;
    } | null | undefined;
    readonly deletedCommentId: string | null | undefined;
    readonly issue: {
      readonly number: number;
      readonly repository: {
        readonly name: string;
        readonly owner: {
          readonly login: string;
        };
      };
    };
    readonly issueBodyUpdated: {
      readonly " $fragmentSpreads": FragmentRefs<"IssueBodyContent">;
    } | null | undefined;
    readonly issueDependenciesSummaryUpdated: {
      readonly blockedBy: {
        readonly nodes: ReadonlyArray<{
          readonly number: number;
          readonly repository: {
            readonly name: string;
            readonly owner: {
              readonly login: string;
            };
          };
          readonly titleHTML: string;
          readonly url: string;
        } | null | undefined> | null | undefined;
      };
      readonly databaseId: number | null | undefined;
      readonly id: string;
      readonly issueDependenciesSummary: {
        readonly blockedBy: number;
        readonly blocking: number;
      };
      readonly parent: {
        readonly id: string;
        readonly number: number;
        readonly repository: {
          readonly nameWithOwner: string;
        };
        readonly state: IssueState;
        readonly stateReason: IssueStateReason | null | undefined;
        readonly subIssuesSummary: {
          readonly completed: number;
          readonly total: number;
        };
        readonly titleHTML: string;
        readonly url: string;
      } | null | undefined;
      readonly repository: {
        readonly isArchived: boolean;
        readonly nameWithOwner: string;
        readonly owner: {
          readonly login: string;
        };
      };
      readonly securityAlerts: {
        readonly nodes: ReadonlyArray<{
          readonly number: number | null | undefined;
          readonly repository: {
            readonly nameWithOwner: string;
          } | null | undefined;
          readonly status: CodeScanningSecurityAlertStatus | null | undefined;
          readonly title: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly state: IssueState;
      readonly topBlockedBy: {
        readonly nodes: ReadonlyArray<{
          readonly id: string;
          readonly number: number;
          readonly repository: {
            readonly name: string;
            readonly nameWithOwner: string;
            readonly owner: {
              readonly login: string;
            };
          };
          readonly state: IssueState;
          readonly stateReason: IssueStateReason | null | undefined;
          readonly title: string;
          readonly titleHTML: string;
          readonly url: string;
        } | null | undefined> | null | undefined;
        readonly pageInfo: {
          readonly hasNextPage: boolean;
        };
      };
      readonly topBlocking: {
        readonly nodes: ReadonlyArray<{
          readonly id: string;
          readonly number: number;
          readonly repository: {
            readonly name: string;
            readonly nameWithOwner: string;
            readonly owner: {
              readonly login: string;
            };
          };
          readonly state: IssueState;
          readonly stateReason: IssueStateReason | null | undefined;
          readonly title: string;
          readonly titleHTML: string;
          readonly url: string;
        } | null | undefined> | null | undefined;
        readonly pageInfo: {
          readonly hasNextPage: boolean;
        };
      };
      readonly viewerCanUpdateMetadata: boolean | null | undefined;
    } | null | undefined;
    readonly issueFieldsUpdated: {
      readonly " $fragmentSpreads": FragmentRefs<"FieldsSectionFieldValues">;
    } | null | undefined;
    readonly issueMetadataUpdated: {
      readonly closedByPullRequestsReferences: {
        readonly nodes: ReadonlyArray<{
          readonly __typename: "PullRequest";
          readonly createdAt: string;
          readonly id: string;
          readonly isDraft: boolean;
          readonly isInMergeQueue: boolean;
          readonly number: number;
          readonly repository: {
            readonly id: string;
            readonly name: string;
            readonly nameWithOwner: string;
            readonly owner: {
              readonly __typename: string;
              readonly id: string;
              readonly login: string;
            };
          };
          readonly state: PullRequestState;
          readonly title: string;
          readonly url: string;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly databaseId: number | null | undefined;
      readonly id: string;
      readonly linkedBranches: {
        readonly nodes: ReadonlyArray<{
          readonly id: string;
          readonly ref: {
            readonly __typename: "Ref";
            readonly associatedPullRequests: {
              readonly totalCount: number;
            };
            readonly id: string;
            readonly name: string;
            readonly repository: {
              readonly defaultBranchRef: {
                readonly associatedPullRequests: {
                  readonly totalCount: number;
                };
                readonly id: string;
                readonly name: string;
                readonly target: {
                  readonly id: string;
                  readonly oid: any;
                } | null | undefined;
              } | null | undefined;
              readonly id: string;
              readonly nameWithOwner: string;
            };
            readonly target: {
              readonly id: string;
              readonly oid: any;
            } | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      };
      readonly linkedPullRequestReleases: {
        readonly nodes: ReadonlyArray<{
          readonly pullRequest: {
            readonly id: string;
          } | null | undefined;
          readonly release: {
            readonly id: string;
            readonly isLatest: boolean;
            readonly isPrerelease: boolean;
            readonly name: string | null | undefined;
            readonly tagName: string;
            readonly url: string;
          };
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly number: number;
      readonly repository: {
        readonly databaseId: number | null | undefined;
        readonly id: string;
        readonly name: string;
        readonly owner: {
          readonly login: string;
        };
      };
      readonly title: string;
      readonly viewerCanLinkBranches: boolean;
      readonly " $fragmentSpreads": FragmentRefs<"AssigneesSectionAssignees" | "LabelsSectionAssignedLabels" | "LinkedPullRequests" | "MilestonesSectionMilestone" | "ProjectsSectionFragment">;
    } | null | undefined;
    readonly issueReactionUpdated: {
      readonly " $fragmentSpreads": FragmentRefs<"ReactionViewerRelayGroups">;
    } | null | undefined;
    readonly issueStateUpdated: {
      readonly " $fragmentSpreads": FragmentRefs<"HeaderState" | "IssueActions">;
    } | null | undefined;
    readonly issueTitleUpdated: {
      readonly " $fragmentSpreads": FragmentRefs<"Header">;
    } | null | undefined;
    readonly issueTransferStateUpdated: {
      readonly " $fragmentSpreads": FragmentRefs<"IssueBodyViewerSubIssues" | "SubIssuesList" | "useHasSubIssues">;
    } | null | undefined;
    readonly issueTypeUpdated: {
      readonly " $fragmentSpreads": FragmentRefs<"HeaderIssueType" | "TypesSectionTypeFragment">;
    } | null | undefined;
    readonly parentIssueUpdated: {
      readonly databaseId: number | null | undefined;
      readonly id: string;
      readonly issueDependenciesSummary: {
        readonly blockedBy: number;
        readonly blocking: number;
      };
      readonly parent: {
        readonly id: string;
        readonly number: number;
        readonly repository: {
          readonly name: string;
          readonly nameWithOwner: string;
          readonly owner: {
            readonly login: string;
          };
        };
        readonly state: IssueState;
        readonly stateReason: IssueStateReason | null | undefined;
        readonly subIssuesSummary: {
          readonly completed: number;
          readonly total: number;
        };
        readonly title: string;
        readonly titleHTML: string;
        readonly url: string;
      } | null | undefined;
      readonly repository: {
        readonly isArchived: boolean;
        readonly nameWithOwner: string;
        readonly owner: {
          readonly login: string;
        };
      };
      readonly securityAlerts: {
        readonly nodes: ReadonlyArray<{
          readonly number: number | null | undefined;
          readonly repository: {
            readonly nameWithOwner: string;
          } | null | undefined;
          readonly status: CodeScanningSecurityAlertStatus | null | undefined;
          readonly title: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly topBlockedBy: {
        readonly nodes: ReadonlyArray<{
          readonly id: string;
          readonly number: number;
          readonly repository: {
            readonly name: string;
            readonly nameWithOwner: string;
            readonly owner: {
              readonly login: string;
            };
          };
          readonly state: IssueState;
          readonly stateReason: IssueStateReason | null | undefined;
          readonly title: string;
          readonly titleHTML: string;
          readonly url: string;
        } | null | undefined> | null | undefined;
        readonly pageInfo: {
          readonly hasNextPage: boolean;
        };
      };
      readonly topBlocking: {
        readonly nodes: ReadonlyArray<{
          readonly id: string;
          readonly number: number;
          readonly repository: {
            readonly name: string;
            readonly nameWithOwner: string;
            readonly owner: {
              readonly login: string;
            };
          };
          readonly state: IssueState;
          readonly stateReason: IssueStateReason | null | undefined;
          readonly title: string;
          readonly titleHTML: string;
          readonly url: string;
        } | null | undefined> | null | undefined;
        readonly pageInfo: {
          readonly hasNextPage: boolean;
        };
      };
      readonly viewerCanUpdateMetadata: boolean | null | undefined;
    } | null | undefined;
    readonly pinnedCommentUpdated: {
      readonly issue: {
        readonly " $fragmentSpreads": FragmentRefs<"PinnedCommentDisplay">;
      };
      readonly " $fragmentSpreads": FragmentRefs<"IssueCommentHeader">;
    } | null | undefined;
    readonly subIssuesUpdated: {
      readonly " $fragmentSpreads": FragmentRefs<"SubIssuesList" | "useHasSubIssues">;
    } | null | undefined;
  };
};
export type IssueViewerSubscriptionMetadataSubscription = {
  response: IssueViewerSubscriptionMetadataSubscription$data;
  variables: IssueViewerSubscriptionMetadataSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "issueId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "issueId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "login",
  "storageKey": null
},
v5 = [
  (v4/*: any*/)
],
v6 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedCommentId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v12 = {
  "kind": "Literal",
  "name": "first",
  "value": 25
},
v13 = [
  (v12/*: any*/)
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oid",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "target",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    (v9/*: any*/)
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameWithOwner",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v19 = [
  (v18/*: any*/)
],
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "PullRequestConnection",
  "kind": "LinkedField",
  "name": "associatedPullRequests",
  "plural": false,
  "selections": (v19/*: any*/),
  "storageKey": null
},
v21 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v22 = {
  "kind": "Literal",
  "name": "includeClosedPrs",
  "value": true
},
v23 = [
  (v21/*: any*/),
  (v22/*: any*/)
],
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDraft",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": (v23/*: any*/),
  "concreteType": "PullRequestConnection",
  "kind": "LinkedField",
  "name": "closedByPullRequestsReferences",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PullRequest",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v9/*: any*/),
        (v24/*: any*/),
        (v2/*: any*/),
        (v11/*: any*/),
        (v25/*: any*/),
        (v26/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isInMergeQueue",
          "storageKey": null
        },
        (v27/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Repository",
          "kind": "LinkedField",
          "name": "repository",
          "plural": false,
          "selections": [
            (v9/*: any*/),
            (v3/*: any*/),
            (v17/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "owner",
              "plural": false,
              "selections": [
                (v9/*: any*/),
                (v4/*: any*/),
                (v14/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v14/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": "closedByPullRequestsReferences(first:10,includeClosedPrs:true)"
},
v29 = [
  (v21/*: any*/)
],
v30 = [
  (v9/*: any*/)
],
v31 = {
  "alias": null,
  "args": (v29/*: any*/),
  "concreteType": "LinkedPullRequestReleaseConnection",
  "kind": "LinkedField",
  "name": "linkedPullRequestReleases",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkedPullRequestRelease",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PullRequest",
          "kind": "LinkedField",
          "name": "pullRequest",
          "plural": false,
          "selections": (v30/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Release",
          "kind": "LinkedField",
          "name": "release",
          "plural": false,
          "selections": [
            (v9/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "tagName",
              "storageKey": null
            },
            (v3/*: any*/),
            (v24/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isPrerelease",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isLatest",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "linkedPullRequestReleases(first:10)"
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanLinkBranches",
  "storageKey": null
},
v33 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "ReactionViewerRelayGroups"
  }
],
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "Issue",
  "kind": "LinkedField",
  "name": "issue",
  "plural": false,
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PinnedCommentDisplay"
    }
  ],
  "storageKey": null
},
v35 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "SubIssuesList"
},
v36 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "useHasSubIssues"
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanUpdateMetadata",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArchived",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    (v38/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
},
v40 = {
  "kind": "Literal",
  "name": "ranked",
  "value": true
},
v41 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 3
  },
  (v40/*: any*/)
],
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "titleHTML",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stateReason",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v44/*: any*/)
  ],
  "storageKey": null
},
v46 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v9/*: any*/),
      (v11/*: any*/),
      (v42/*: any*/),
      (v24/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Repository",
        "kind": "LinkedField",
        "name": "repository",
        "plural": false,
        "selections": [
          (v17/*: any*/),
          (v3/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      },
      (v25/*: any*/),
      (v43/*: any*/)
    ],
    "storageKey": null
  },
  (v45/*: any*/)
],
v47 = {
  "alias": "topBlockedBy",
  "args": (v41/*: any*/),
  "concreteType": "IssueConnection",
  "kind": "LinkedField",
  "name": "blockedBy",
  "plural": false,
  "selections": (v46/*: any*/),
  "storageKey": "blockedBy(first:3,ranked:true)"
},
v48 = {
  "alias": "topBlocking",
  "args": (v41/*: any*/),
  "concreteType": "IssueConnection",
  "kind": "LinkedField",
  "name": "blocking",
  "plural": false,
  "selections": (v46/*: any*/),
  "storageKey": "blocking(first:3,ranked:true)"
},
v49 = {
  "kind": "Literal",
  "name": "first",
  "value": 100
},
v50 = [
  (v49/*: any*/)
],
v51 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v17/*: any*/)
  ],
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": (v50/*: any*/),
  "concreteType": "CodeScanningSecurityAlertConnection",
  "kind": "LinkedField",
  "name": "securityAlerts",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CodeScanningSecurityAlert",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        (v51/*: any*/),
        (v52/*: any*/),
        (v11/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": "securityAlerts(first:100)"
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "blockedBy",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueDependenciesSummary",
  "kind": "LinkedField",
  "name": "issueDependenciesSummary",
  "plural": false,
  "selections": [
    (v54/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "blocking",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "total",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "concreteType": "SubIssuesSummary",
  "kind": "LinkedField",
  "name": "subIssuesSummary",
  "plural": false,
  "selections": [
    (v56/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "completed",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v58 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  },
  (v40/*: any*/)
],
v59 = [
  (v14/*: any*/),
  (v4/*: any*/),
  (v9/*: any*/)
],
v60 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v59/*: any*/),
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v60/*: any*/),
    (v9/*: any*/)
  ],
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": 64
    }
  ],
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": "avatarUrl(size:64)"
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCopilot",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAgent",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v66 = {
  "kind": "InlineFragment",
  "selections": (v30/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v67 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 20
    }
  ],
  "concreteType": "AssigneeConnection",
  "kind": "LinkedField",
  "name": "assignedActors",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v14/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            (v9/*: any*/),
            (v4/*: any*/),
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profileResourcePath",
              "storageKey": null
            },
            (v62/*: any*/),
            {
              "kind": "InlineFragment",
              "selections": [
                (v63/*: any*/),
                (v64/*: any*/),
                (v65/*: any*/)
              ],
              "type": "Bot",
              "abstractKey": null
            }
          ],
          "type": "Actor",
          "abstractKey": "__isActor"
        },
        (v66/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": "assignedActors(first:20)"
},
v68 = {
  "alias": null,
  "args": null,
  "concreteType": "Bot",
  "kind": "LinkedField",
  "name": "assignee",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v4/*: any*/),
    (v62/*: any*/),
    (v63/*: any*/),
    (v64/*: any*/),
    (v65/*: any*/)
  ],
  "storageKey": null
},
v69 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isNode"
},
v70 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "assigner",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isActor"
    },
    (v4/*: any*/),
    (v9/*: any*/),
    (v69/*: any*/)
  ],
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "closed",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "concreteType": "Milestone",
  "kind": "LinkedField",
  "name": "milestone",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v11/*: any*/),
    (v71/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dueOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "progressPercentage",
      "storageKey": null
    },
    (v24/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "closedAt",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "target",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    (v15/*: any*/),
    (v9/*: any*/)
  ],
  "storageKey": null
},
v74 = {
  "alias": "linkedPullRequests",
  "args": [
    (v21/*: any*/),
    {
      "kind": "Literal",
      "name": "includeClosedPrs",
      "value": false
    },
    {
      "kind": "Literal",
      "name": "orderByState",
      "value": true
    }
  ],
  "concreteType": "PullRequestConnection",
  "kind": "LinkedField",
  "name": "closedByPullRequestsReferences",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PullRequest",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Repository",
          "kind": "LinkedField",
          "name": "repository",
          "plural": false,
          "selections": [
            (v17/*: any*/),
            (v9/*: any*/),
            (v3/*: any*/),
            (v60/*: any*/)
          ],
          "storageKey": null
        },
        (v25/*: any*/),
        (v26/*: any*/),
        (v24/*: any*/),
        (v2/*: any*/),
        (v9/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": "closedByPullRequestsReferences(first:10,includeClosedPrs:false,orderByState:true)"
},
v75 = [
  (v49/*: any*/),
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": {
      "direction": "ASC",
      "field": "NAME"
    }
  }
],
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameHTML",
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    (v44/*: any*/)
  ],
  "storageKey": null
},
v81 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": (v75/*: any*/),
      "concreteType": "LabelConnection",
      "kind": "LinkedField",
      "name": "labels",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LabelEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Label",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v9/*: any*/),
                (v76/*: any*/),
                (v3/*: any*/),
                (v77/*: any*/),
                (v78/*: any*/),
                (v24/*: any*/),
                (v14/*: any*/)
              ],
              "storageKey": null
            },
            (v79/*: any*/)
          ],
          "storageKey": null
        },
        (v80/*: any*/)
      ],
      "storageKey": "labels(first:100,orderBy:{\"direction\":\"ASC\",\"field\":\"NAME\"})"
    },
    {
      "alias": null,
      "args": (v75/*: any*/),
      "filters": [
        "orderBy"
      ],
      "handle": "connection",
      "key": "MetadataSectionAssignedLabels_labels",
      "kind": "LinkedHandle",
      "name": "labels"
    },
    (v69/*: any*/)
  ],
  "type": "Labelable",
  "abstractKey": "__isLabelable"
},
v82 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v38/*: any*/)
  ],
  "storageKey": null
},
v83 = [
  {
    "kind": "Literal",
    "name": "allowSameEnterprise",
    "value": true
  },
  (v12/*: any*/)
],
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanUpdate",
  "storageKey": null
},
v85 = [
  {
    "kind": "Literal",
    "name": "name",
    "value": "Status"
  }
],
v86 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "optionId",
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": (v83/*: any*/),
  "concreteType": "ProjectV2ItemConnection",
  "kind": "LinkedField",
  "name": "projectItems",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectV2ItemEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectV2Item",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v9/*: any*/),
            (v38/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectV2",
              "kind": "LinkedField",
              "name": "project",
              "plural": false,
              "selections": [
                (v9/*: any*/),
                (v11/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "template",
                  "storageKey": null
                },
                (v84/*: any*/),
                (v24/*: any*/),
                {
                  "alias": null,
                  "args": (v85/*: any*/),
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "field",
                  "plural": false,
                  "selections": [
                    (v14/*: any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v10/*: any*/),
                        (v9/*: any*/),
                        (v3/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ProjectV2SingleSelectFieldOption",
                          "kind": "LinkedField",
                          "name": "options",
                          "plural": true,
                          "selections": [
                            (v9/*: any*/),
                            (v86/*: any*/),
                            (v3/*: any*/),
                            (v77/*: any*/),
                            (v76/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "descriptionHTML",
                              "storageKey": null
                            },
                            (v78/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "type": "ProjectV2SingleSelectField",
                      "abstractKey": null
                    },
                    (v66/*: any*/)
                  ],
                  "storageKey": "field(name:\"Status\")"
                },
                (v71/*: any*/),
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasReachedItemsLimit",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": (v85/*: any*/),
              "concreteType": null,
              "kind": "LinkedField",
              "name": "fieldValueByName",
              "plural": false,
              "selections": [
                (v14/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v9/*: any*/),
                    (v86/*: any*/),
                    (v3/*: any*/),
                    (v77/*: any*/),
                    (v76/*: any*/)
                  ],
                  "type": "ProjectV2ItemFieldSingleSelectValue",
                  "abstractKey": null
                },
                (v66/*: any*/)
              ],
              "storageKey": "fieldValueByName(name:\"Status\")"
            },
            (v14/*: any*/)
          ],
          "storageKey": null
        },
        (v79/*: any*/)
      ],
      "storageKey": null
    },
    (v80/*: any*/)
  ],
  "storageKey": "projectItems(allowSameEnterprise:true,first:25)"
},
v88 = {
  "alias": null,
  "args": (v83/*: any*/),
  "filters": [
    "allowedOwner",
    "allowSameEnterprise"
  ],
  "handle": "connection",
  "key": "ProjectSection_projectItems",
  "kind": "LinkedHandle",
  "name": "projectItems"
},
v89 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "unfurlReferences",
      "value": true
    }
  ],
  "kind": "ScalarField",
  "name": "bodyHTML",
  "storageKey": "bodyHTML(unfurlReferences:true)"
},
v91 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bodyVersion",
  "storageKey": null
},
v92 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
},
v93 = {
  "alias": null,
  "args": null,
  "concreteType": "Issue",
  "kind": "LinkedField",
  "name": "duplicateOf",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v24/*: any*/),
    (v61/*: any*/),
    (v9/*: any*/)
  ],
  "storageKey": null
},
v94 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    (v9/*: any*/)
  ],
  "storageKey": null
},
v95 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dataType",
  "storageKey": null
},
v96 = [
  (v9/*: any*/),
  (v3/*: any*/),
  (v95/*: any*/)
],
v97 = [
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ReactionGroup",
        "kind": "LinkedField",
        "name": "reactionGroups",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "content",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "viewerHasReacted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 5
              }
            ],
            "concreteType": "ReactorConnection",
            "kind": "LinkedField",
            "name": "reactors",
            "plural": false,
            "selections": [
              (v18/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v14/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v5/*: any*/),
                    "type": "User",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v4/*: any*/),
                      (v63/*: any*/),
                      (v64/*: any*/),
                      (v65/*: any*/)
                    ],
                    "type": "Bot",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v5/*: any*/),
                    "type": "Organization",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v5/*: any*/),
                    "type": "Mannequin",
                    "abstractKey": null
                  },
                  (v66/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "reactors(first:5)"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Reactable",
    "abstractKey": "__isReactable"
  },
  (v9/*: any*/)
],
v98 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v99 = [
  (v9/*: any*/),
  (v3/*: any*/),
  (v95/*: any*/),
  (v98/*: any*/)
],
v100 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v101 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": null
},
v102 = [
  (v3/*: any*/)
],
v103 = {
  "kind": "InlineFragment",
  "selections": (v102/*: any*/),
  "type": "User",
  "abstractKey": null
},
v104 = {
  "kind": "InlineFragment",
  "selections": (v102/*: any*/),
  "type": "EnterpriseUserAccount",
  "abstractKey": null
},
v105 = {
  "kind": "InlineFragment",
  "selections": (v102/*: any*/),
  "type": "Mannequin",
  "abstractKey": null
},
v106 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanUnpin",
  "storageKey": null
},
v107 = {
  "alias": null,
  "args": null,
  "concreteType": "PinnedIssueComment",
  "kind": "LinkedField",
  "name": "pinnedIssueComment",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "pinnedBy",
      "plural": false,
      "selections": (v59/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IssueComment",
      "kind": "LinkedField",
      "name": "issueComment",
      "plural": false,
      "selections": [
        (v9/*: any*/),
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "limit",
              "value": 700
            },
            {
              "kind": "Literal",
              "name": "stripBlockElements",
              "value": false
            }
          ],
          "kind": "ScalarField",
          "name": "shortBodyHTML",
          "storageKey": "shortBodyHTML(limit:700,stripBlockElements:false)"
        },
        (v27/*: any*/),
        (v24/*: any*/),
        (v106/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "author",
          "plural": false,
          "selections": [
            (v14/*: any*/),
            (v4/*: any*/),
            (v101/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profileUrl",
              "storageKey": null
            },
            (v9/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v9/*: any*/)
  ],
  "storageKey": null
},
v108 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "authorAssociation",
  "storageKey": null
},
v109 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanDelete",
  "storageKey": null
},
v110 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanMinimize",
  "storageKey": null
},
v111 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanUnminimize",
  "storageKey": null
},
v112 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanReport",
  "storageKey": null
},
v113 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanReportToMaintainer",
  "storageKey": null
},
v114 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanBlockFromOrg",
  "storageKey": null
},
v115 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanUnblockFromOrg",
  "storageKey": null
},
v116 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanPin",
  "storageKey": null
},
v117 = {
  "alias": null,
  "args": null,
  "concreteType": "App",
  "kind": "LinkedField",
  "name": "viaApp",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v24/*: any*/),
    (v9/*: any*/)
  ],
  "storageKey": null
},
v118 = {
  "alias": "isHidden",
  "args": null,
  "kind": "ScalarField",
  "name": "isMinimized",
  "storageKey": null
},
v119 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "minimizedReason",
  "storageKey": null
},
v120 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showSpammyBadge",
  "storageKey": null
},
v121 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdViaEmail",
  "storageKey": null
},
v122 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerDidAuthor",
  "storageKey": null
},
v123 = {
  "alias": null,
  "args": null,
  "concreteType": "Sponsorship",
  "kind": "LinkedField",
  "name": "authorToRepoOwnerSponsorship",
  "plural": false,
  "selections": [
    (v27/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isActive",
      "storageKey": null
    },
    (v9/*: any*/)
  ],
  "storageKey": null
},
v124 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "owner",
      "plural": false,
      "selections": [
        (v14/*: any*/),
        (v9/*: any*/),
        (v4/*: any*/),
        (v24/*: any*/)
      ],
      "storageKey": null
    },
    (v92/*: any*/)
  ],
  "storageKey": null
},
v125 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "pinnedBy",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v9/*: any*/)
  ],
  "storageKey": null
},
v126 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanReadUserContentEdits",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastEditedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserContentEdit",
      "kind": "LinkedField",
      "name": "lastUserContentEdit",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "editor",
          "plural": false,
          "selections": [
            (v14/*: any*/),
            (v24/*: any*/),
            (v4/*: any*/),
            (v9/*: any*/)
          ],
          "storageKey": null
        },
        (v9/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Comment",
  "abstractKey": "__isComment"
},
v127 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pendingMinimizeReason",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pendingBlock",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pendingUnblock",
      "storageKey": null
    }
  ]
},
v128 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerCanPush",
  "storageKey": null
},
v129 = {
  "alias": "subIssuesConnection",
  "args": null,
  "concreteType": "IssueConnection",
  "kind": "LinkedField",
  "name": "subIssues",
  "plural": false,
  "selections": (v19/*: any*/),
  "storageKey": null
},
v130 = {
  "alias": null,
  "args": (v50/*: any*/),
  "concreteType": "IssueConnection",
  "kind": "LinkedField",
  "name": "subIssues",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Issue",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v9/*: any*/),
        (v71/*: any*/),
        (v25/*: any*/),
        (v43/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "IssueDependenciesSummary",
          "kind": "LinkedField",
          "name": "issueDependenciesSummary",
          "plural": false,
          "selections": [
            (v54/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v29/*: any*/),
          "concreteType": "UserConnection",
          "kind": "LinkedField",
          "name": "assignees",
          "plural": false,
          "selections": [
            (v18/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "UserEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "User",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v9/*: any*/),
                    (v4/*: any*/),
                    (v101/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "assignees(first:10)"
        },
        (v24/*: any*/),
        (v61/*: any*/),
        (v10/*: any*/),
        (v2/*: any*/),
        (v11/*: any*/),
        (v42/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "IssueType",
          "kind": "LinkedField",
          "name": "issueType",
          "plural": false,
          "selections": [
            (v9/*: any*/),
            (v3/*: any*/),
            (v76/*: any*/)
          ],
          "storageKey": null
        },
        (v57/*: any*/),
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 0
            },
            (v22/*: any*/)
          ],
          "concreteType": "PullRequestConnection",
          "kind": "LinkedField",
          "name": "closedByPullRequestsReferences",
          "plural": false,
          "selections": (v19/*: any*/),
          "storageKey": "closedByPullRequestsReferences(first:0,includeClosedPrs:true)"
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "subIssues(first:100)"
},
v131 = {
  "alias": null,
  "args": null,
  "concreteType": "Issue",
  "kind": "LinkedField",
  "name": "parent",
  "plural": false,
  "selections": (v30/*: any*/),
  "storageKey": null
},
v132 = {
  "alias": null,
  "args": null,
  "concreteType": "SubIssuesSummary",
  "kind": "LinkedField",
  "name": "subIssuesSummary",
  "plural": false,
  "selections": [
    (v56/*: any*/)
  ],
  "storageKey": null
},
v133 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    (v38/*: any*/),
    (v60/*: any*/),
    (v9/*: any*/)
  ],
  "storageKey": null
},
v134 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v9/*: any*/),
      (v11/*: any*/),
      (v42/*: any*/),
      (v24/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Repository",
        "kind": "LinkedField",
        "name": "repository",
        "plural": false,
        "selections": [
          (v17/*: any*/),
          (v3/*: any*/),
          (v60/*: any*/),
          (v9/*: any*/)
        ],
        "storageKey": null
      },
      (v25/*: any*/),
      (v43/*: any*/)
    ],
    "storageKey": null
  },
  (v45/*: any*/)
],
v135 = {
  "alias": "topBlockedBy",
  "args": (v41/*: any*/),
  "concreteType": "IssueConnection",
  "kind": "LinkedField",
  "name": "blockedBy",
  "plural": false,
  "selections": (v134/*: any*/),
  "storageKey": "blockedBy(first:3,ranked:true)"
},
v136 = {
  "alias": "topBlocking",
  "args": (v41/*: any*/),
  "concreteType": "IssueConnection",
  "kind": "LinkedField",
  "name": "blocking",
  "plural": false,
  "selections": (v134/*: any*/),
  "storageKey": "blocking(first:3,ranked:true)"
},
v137 = {
  "alias": null,
  "args": (v50/*: any*/),
  "concreteType": "CodeScanningSecurityAlertConnection",
  "kind": "LinkedField",
  "name": "securityAlerts",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CodeScanningSecurityAlert",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        (v94/*: any*/),
        (v52/*: any*/),
        (v11/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": "securityAlerts(first:100)"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IssueViewerSubscriptionMetadataSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "IssueUpdatedPayload",
        "kind": "LinkedField",
        "name": "issueUpdated",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueMetadataUpdated",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "LabelsSectionAssignedLabels"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AssigneesSectionAssignees"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "MilestonesSectionMilestone"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ProjectsSectionFragment"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Repository",
                "kind": "LinkedField",
                "name": "repository",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v3/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              (v9/*: any*/),
              (v11/*: any*/),
              (v2/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": (v13/*: any*/),
                "concreteType": "LinkedBranchConnection",
                "kind": "LinkedField",
                "name": "linkedBranches",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LinkedBranch",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Ref",
                        "kind": "LinkedField",
                        "name": "ref",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v9/*: any*/),
                          (v14/*: any*/),
                          (v16/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Repository",
                            "kind": "LinkedField",
                            "name": "repository",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              (v17/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Ref",
                                "kind": "LinkedField",
                                "name": "defaultBranchRef",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v9/*: any*/),
                                  (v16/*: any*/),
                                  (v20/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v20/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "linkedBranches(first:25)"
              },
              (v28/*: any*/),
              (v31/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "LinkedPullRequests"
              },
              (v32/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueBodyUpdated",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "IssueBodyContent"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueTitleUpdated",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "Header"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueStateUpdated",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "HeaderState"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "IssueActions"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueTypeUpdated",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "HeaderIssueType"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TypesSectionTypeFragment"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueReactionUpdated",
            "plural": false,
            "selections": (v33/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueFieldsUpdated",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "FieldsSectionFieldValues"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IssueComment",
            "kind": "LinkedField",
            "name": "commentReactionUpdated",
            "plural": false,
            "selections": (v33/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IssueComment",
            "kind": "LinkedField",
            "name": "commentUpdated",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "IssueCommentViewerMarkdownViewer"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "IssueCommentEditorBodyFragment"
              },
              (v34/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IssueComment",
            "kind": "LinkedField",
            "name": "pinnedCommentUpdated",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "IssueCommentHeader"
              },
              (v34/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "subIssuesUpdated",
            "plural": false,
            "selections": [
              (v35/*: any*/),
              (v36/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueTransferStateUpdated",
            "plural": false,
            "selections": [
              (v35/*: any*/),
              (v36/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "IssueBodyViewerSubIssues"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "parentIssueUpdated",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v37/*: any*/),
              (v39/*: any*/),
              (v47/*: any*/),
              (v48/*: any*/),
              (v53/*: any*/),
              (v55/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Issue",
                "kind": "LinkedField",
                "name": "parent",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Repository",
                    "kind": "LinkedField",
                    "name": "repository",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v17/*: any*/),
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v25/*: any*/),
                  (v43/*: any*/),
                  (v11/*: any*/),
                  (v42/*: any*/),
                  (v24/*: any*/),
                  (v57/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueDependenciesSummaryUpdated",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v37/*: any*/),
              (v39/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Issue",
                "kind": "LinkedField",
                "name": "parent",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v42/*: any*/),
                  (v24/*: any*/),
                  (v2/*: any*/),
                  (v51/*: any*/),
                  (v25/*: any*/),
                  (v43/*: any*/),
                  (v57/*: any*/)
                ],
                "storageKey": null
              },
              (v47/*: any*/),
              (v48/*: any*/),
              (v53/*: any*/),
              (v25/*: any*/),
              (v55/*: any*/),
              {
                "alias": null,
                "args": (v58/*: any*/),
                "concreteType": "IssueConnection",
                "kind": "LinkedField",
                "name": "blockedBy",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Issue",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v42/*: any*/),
                      (v2/*: any*/),
                      (v24/*: any*/),
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "blockedBy(first:1,ranked:true)"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "EventSubscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IssueViewerSubscriptionMetadataSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "IssueUpdatedPayload",
        "kind": "LinkedField",
        "name": "issueUpdated",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v61/*: any*/),
              (v9/*: any*/)
            ],
            "storageKey": null
          },
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedCommentId"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueMetadataUpdated",
            "plural": false,
            "selections": [
              (v67/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AgentAssignment",
                "kind": "LinkedField",
                "name": "agentAssignments",
                "plural": true,
                "selections": [
                  (v68/*: any*/),
                  (v70/*: any*/)
                ],
                "storageKey": null
              },
              (v72/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Repository",
                "kind": "LinkedField",
                "name": "repository",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v3/*: any*/),
                  (v60/*: any*/),
                  (v17/*: any*/)
                ],
                "storageKey": null
              },
              (v9/*: any*/),
              (v11/*: any*/),
              (v2/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": (v13/*: any*/),
                "concreteType": "LinkedBranchConnection",
                "kind": "LinkedField",
                "name": "linkedBranches",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LinkedBranch",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Ref",
                        "kind": "LinkedField",
                        "name": "ref",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v9/*: any*/),
                          (v14/*: any*/),
                          (v73/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Repository",
                            "kind": "LinkedField",
                            "name": "repository",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              (v17/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Ref",
                                "kind": "LinkedField",
                                "name": "defaultBranchRef",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v9/*: any*/),
                                  (v73/*: any*/),
                                  (v20/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v20/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "linkedBranches(first:25)"
              },
              (v28/*: any*/),
              (v31/*: any*/),
              (v74/*: any*/),
              (v32/*: any*/),
              (v81/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v82/*: any*/),
                      (v87/*: any*/),
                      (v88/*: any*/),
                      (v37/*: any*/)
                    ],
                    "type": "Issue",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v82/*: any*/),
                      (v87/*: any*/),
                      (v88/*: any*/),
                      (v84/*: any*/)
                    ],
                    "type": "PullRequest",
                    "abstractKey": null
                  }
                ],
                "type": "IssueOrPullRequest",
                "abstractKey": "__isIssueOrPullRequest"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueBodyUpdated",
            "plural": false,
            "selections": [
              (v89/*: any*/),
              (v90/*: any*/),
              (v91/*: any*/),
              (v9/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueTitleUpdated",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v2/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Repository",
                "kind": "LinkedField",
                "name": "repository",
                "plural": false,
                "selections": [
                  (v17/*: any*/),
                  (v9/*: any*/),
                  (v3/*: any*/),
                  (v60/*: any*/),
                  (v38/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isWritable",
                    "storageKey": null
                  },
                  (v92/*: any*/)
                ],
                "storageKey": null
              },
              (v42/*: any*/),
              (v24/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanUpdateNext",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v76/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              (v25/*: any*/),
              (v43/*: any*/),
              (v93/*: any*/),
              (v74/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AgentAssignment",
                "kind": "LinkedField",
                "name": "agentAssignments",
                "plural": true,
                "selections": [
                  (v14/*: any*/),
                  (v68/*: any*/),
                  (v70/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "linkedPullRequestsIncludingClosed",
                "args": (v23/*: any*/),
                "concreteType": "PullRequestConnection",
                "kind": "LinkedField",
                "name": "closedByPullRequestsReferences",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PullRequest",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      (v10/*: any*/),
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "closedByPullRequestsReferences(first:10,includeClosedPrs:true)"
              },
              (v57/*: any*/),
              (v67/*: any*/),
              (v72/*: any*/),
              (v81/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueStateUpdated",
            "plural": false,
            "selections": [
              (v25/*: any*/),
              (v43/*: any*/),
              (v93/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Repository",
                "kind": "LinkedField",
                "name": "repository",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v17/*: any*/),
                  (v60/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueTypeUpdated",
            "plural": false,
            "selections": [
              (v94/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "IssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v76/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isEnabled",
                    "storageKey": null
                  },
                  (v78/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "pinnedFields",
                    "plural": true,
                    "selections": [
                      (v14/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v96/*: any*/),
                        "type": "IssueFieldText",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v96/*: any*/),
                        "type": "IssueFieldSingleSelect",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v96/*: any*/),
                        "type": "IssueFieldDate",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v96/*: any*/),
                        "type": "IssueFieldNumber",
                        "abstractKey": null
                      },
                      (v66/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v9/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueReactionUpdated",
            "plural": false,
            "selections": (v97/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueFieldsUpdated",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              {
                "alias": null,
                "args": (v13/*: any*/),
                "concreteType": "IssueFieldValueConnection",
                "kind": "LinkedField",
                "name": "issueFieldValues",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v14/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v99/*: any*/),
                                "type": "IssueFieldText",
                                "abstractKey": null
                              },
                              (v66/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v100/*: any*/)
                        ],
                        "type": "IssueFieldTextValue",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v99/*: any*/),
                                "type": "IssueFieldSingleSelect",
                                "abstractKey": null
                              },
                              (v66/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v86/*: any*/),
                          (v3/*: any*/),
                          (v76/*: any*/),
                          (v78/*: any*/)
                        ],
                        "type": "IssueFieldSingleSelectValue",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v99/*: any*/),
                                "type": "IssueFieldMultiSelect",
                                "abstractKey": null
                              },
                              (v66/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "IssueFieldSingleSelectOption",
                            "kind": "LinkedField",
                            "name": "options",
                            "plural": true,
                            "selections": [
                              (v9/*: any*/),
                              (v3/*: any*/),
                              (v76/*: any*/),
                              (v78/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "multiSelectValue",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                          }
                        ],
                        "type": "IssueFieldMultiSelectValue",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v99/*: any*/),
                                "type": "IssueFieldDate",
                                "abstractKey": null
                              },
                              (v66/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v100/*: any*/)
                        ],
                        "type": "IssueFieldDateValue",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "field",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v99/*: any*/),
                                "type": "IssueFieldNumber",
                                "abstractKey": null
                              },
                              (v66/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": "numberValue",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                          }
                        ],
                        "type": "IssueFieldNumberValue",
                        "abstractKey": null
                      },
                      (v66/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "issueFieldValues(first:25)"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanSetFields",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "IssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IssueComment",
            "kind": "LinkedField",
            "name": "commentReactionUpdated",
            "plural": false,
            "selections": (v97/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IssueComment",
            "kind": "LinkedField",
            "name": "commentUpdated",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v89/*: any*/),
              (v90/*: any*/),
              (v91/*: any*/),
              (v84/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  (v4/*: any*/),
                  (v101/*: any*/),
                  (v9/*: any*/),
                  (v103/*: any*/),
                  (v104/*: any*/),
                  (v105/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Issue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": (v59/*: any*/),
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  (v107/*: any*/)
                ],
                "storageKey": null
              },
              (v10/*: any*/),
              (v24/*: any*/),
              (v27/*: any*/),
              (v108/*: any*/),
              (v109/*: any*/),
              (v110/*: any*/),
              (v111/*: any*/),
              (v112/*: any*/),
              (v113/*: any*/),
              (v114/*: any*/),
              (v115/*: any*/),
              (v116/*: any*/),
              (v106/*: any*/),
              (v117/*: any*/),
              (v118/*: any*/),
              (v119/*: any*/),
              (v120/*: any*/),
              (v121/*: any*/),
              (v122/*: any*/),
              (v123/*: any*/),
              (v124/*: any*/),
              (v125/*: any*/),
              (v126/*: any*/),
              (v127/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IssueComment",
            "kind": "LinkedField",
            "name": "pinnedCommentUpdated",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v24/*: any*/),
              (v27/*: any*/),
              (v89/*: any*/),
              (v108/*: any*/),
              (v84/*: any*/),
              (v109/*: any*/),
              (v110/*: any*/),
              (v111/*: any*/),
              (v112/*: any*/),
              (v113/*: any*/),
              (v114/*: any*/),
              (v115/*: any*/),
              (v116/*: any*/),
              (v106/*: any*/),
              (v117/*: any*/),
              (v118/*: any*/),
              (v119/*: any*/),
              (v120/*: any*/),
              (v121/*: any*/),
              (v122/*: any*/),
              (v123/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                  (v14/*: any*/),
                  (v9/*: any*/),
                  (v4/*: any*/),
                  (v103/*: any*/),
                  (v104/*: any*/),
                  (v105/*: any*/)
                ],
                "storageKey": null
              },
              (v124/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Issue",
                "kind": "LinkedField",
                "name": "issue",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v2/*: any*/),
                  (v107/*: any*/)
                ],
                "storageKey": null
              },
              (v125/*: any*/),
              (v126/*: any*/),
              (v127/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "subIssuesUpdated",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Repository",
                "kind": "LinkedField",
                "name": "repository",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v60/*: any*/),
                  (v9/*: any*/),
                  (v17/*: any*/),
                  (v98/*: any*/),
                  (v128/*: any*/)
                ],
                "storageKey": null
              },
              (v129/*: any*/),
              (v130/*: any*/),
              (v10/*: any*/),
              (v2/*: any*/),
              (v131/*: any*/),
              (v132/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueTransferStateUpdated",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Repository",
                "kind": "LinkedField",
                "name": "repository",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v60/*: any*/),
                  (v9/*: any*/),
                  (v17/*: any*/),
                  (v98/*: any*/),
                  (v128/*: any*/),
                  (v38/*: any*/)
                ],
                "storageKey": null
              },
              (v129/*: any*/),
              (v130/*: any*/),
              (v10/*: any*/),
              (v2/*: any*/),
              (v131/*: any*/),
              (v132/*: any*/),
              (v37/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "parentIssueUpdated",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v37/*: any*/),
              (v133/*: any*/),
              (v135/*: any*/),
              (v136/*: any*/),
              (v137/*: any*/),
              (v55/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Issue",
                "kind": "LinkedField",
                "name": "parent",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Repository",
                    "kind": "LinkedField",
                    "name": "repository",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v17/*: any*/),
                      (v60/*: any*/),
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v25/*: any*/),
                  (v43/*: any*/),
                  (v11/*: any*/),
                  (v42/*: any*/),
                  (v24/*: any*/),
                  (v57/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Issue",
            "kind": "LinkedField",
            "name": "issueDependenciesSummaryUpdated",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v37/*: any*/),
              (v133/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Issue",
                "kind": "LinkedField",
                "name": "parent",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v42/*: any*/),
                  (v24/*: any*/),
                  (v2/*: any*/),
                  (v94/*: any*/),
                  (v25/*: any*/),
                  (v43/*: any*/),
                  (v57/*: any*/)
                ],
                "storageKey": null
              },
              (v135/*: any*/),
              (v136/*: any*/),
              (v137/*: any*/),
              (v25/*: any*/),
              (v55/*: any*/),
              {
                "alias": null,
                "args": (v58/*: any*/),
                "concreteType": "IssueConnection",
                "kind": "LinkedField",
                "name": "blockedBy",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Issue",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v42/*: any*/),
                      (v2/*: any*/),
                      (v24/*: any*/),
                      (v61/*: any*/),
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "blockedBy(first:1,ranked:true)"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "d2a48905b573ac486ae1fdc23d104aae",
    "metadata": {},
    "name": "IssueViewerSubscriptionMetadataSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "d27e2ec3c8edf7a17e577ad996dbb9fa";

export default node;
